
import React from "react";
import { 
  Table, 
  TableHeader, 
  TableRow, 
  TableHead, 
  TableBody, 
  TableCell 
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Solution } from "@/types/solutions";

interface SolutionListViewProps {
  solutions: Solution[];
  addToCart: (solution: Solution) => void;
  cart: Solution[];
  getAgencyColor: (agency: string) => string;
  getCommercialTypeColor: (type: string) => string;
}

const SolutionListView: React.FC<SolutionListViewProps> = ({
  solutions,
  addToCart,
  cart,
  getAgencyColor,
  getCommercialTypeColor
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Solution</TableHead>
          <TableHead>Agency</TableHead>
          <TableHead>Creator</TableHead>
          <TableHead>Type</TableHead>
          <TableHead>Price</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {solutions.map((solution) => (
          <TableRow key={solution.id}>
            <TableCell className="font-medium">
              <div>
                {solution.title}
                <p className="text-xs text-gray-500 mt-1">{solution.category}</p>
                {solution.capturedDate && (
                  <p className="text-xs text-gray-400">Captured on {solution.capturedDate}</p>
                )}
              </div>
            </TableCell>
            <TableCell>
              <Badge variant="outline" className={getAgencyColor(solution.agency)}>
                {solution.agency}
              </Badge>
            </TableCell>
            <TableCell>{solution.creator}</TableCell>
            <TableCell>
              <Badge variant="outline" className={getCommercialTypeColor(solution.commercialType)}>
                {solution.commercialType}
              </Badge>
            </TableCell>
            <TableCell>${solution.price.toLocaleString()}</TableCell>
            <TableCell>
              <Button 
                size="sm" 
                onClick={() => addToCart(solution)}
                disabled={cart.some(item => item.id === solution.id)}
              >
                {cart.some(item => item.id === solution.id) ? 'Added' : 'Add to Cart'}
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SolutionListView;
